// Steps for homepage
const careerSiteSteps = [
{
    element: ".page-1",
    popover: {
        title: '🥳 <br>Career page',
        description: '<b>You can prepare pages here just as easily as in MS Word.</b> If you already have your own career page, you can skip this section.',
        position: 'bottom-left',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".guide-step-carreersite-1",
    popover: {
        title: ' ',
        description: 'Here you can specify a company color that will appear across the whole career page.',
        position: 'bottom-right',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".body-container",
    popover: {
        title: ' ',
        description: 'Page content can be edited by clicking directly on a text just like in MS Word.',
        position: 'top',
        showButtons: true,
    },
},
{
    element: ".footer",
    popover: {
        title: ' ',
        description: 'A list of all currently published positions can be found on the careers page here.',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".footer-container",
    popover: {
        title: ' ',
        description: '<b>Do you need help?</b> We would be happy to record a video interview with your CEO or a virtual company tour to give candidates a closer look at how things work in your company. Contact us.',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: "#start-guide",
    popover: {
        title: '🥳 <br>Done!',
        description: '<b>Remember that you can return to the guide at any time</b> by clicking on the Onboardio ship icon at the bottom left.<br>',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
        nextBtnText: 'I understand',
        doneBtnText: 'Roger', // Next button text for this step
    },
},

]



export default careerSiteSteps
